
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyCFO from './components/WhyCFO';
import Team from './components/Team';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import FAQ from './components/FAQ';
import CounterSection from "./components/CounterSection";

function App() {
  return (
    <>
      
      <Navbar />
      <Hero />
      <WhyCFO />
      <Team />
      <CounterSection />
      <Services />
      <Testimonials />
      <FAQ />
      <CTA />
      <Footer />
    </>
  );
}

export default App;
